import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridToolbarComponent } from './grid-toolbar/grid-toolbar.component';
import { McbGridJalaliDateFilterCellComponent } from './grid-jalali-date-filter-cell/grid-jalali-date-filter-cell.component';
import { DatePickerModule } from '../../date-picker/date-picker.module';

@NgModule({
  declarations: [
    GridToolbarComponent,
    McbGridJalaliDateFilterCellComponent
  ],
  imports: [
    CommonModule,
    DatePickerModule
  ],
  exports: [
    GridToolbarComponent,
    McbGridJalaliDateFilterCellComponent
  ]
})
export class GridExtensionModule { }
